import { useState, useEffect, useCallback, useMemo } from "react";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import BetTableTeenPatti20c from "../../casinoComponents/betTableTeenPatti20c";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import {
  getCasinoGameDetails,
  getMatchExposure,
  getCasinoOpenBets,
} from "../../../apiservices/CasionApi";
import Teen20RefCardsOverlay from "../../casinoComponents/videoBox/overlays/Teen20RefCardsOverlay";
import Teen20RefResults from "../resultui/resultTeen20/Teen20RefResults";
import Teen20RightSide from "../teen20/Teen20RightSide";
import "../../../styles/games/teen20.css";

/**
 * 20-20 Teenpatti VIP — reference admin /admin/casino/vip/teenpattit20 (local /admin/casino/teen20v).
 * The reference page uses API type "teen20v1" (our backend serves it under the same name) and renders
 * exactly the 20-20 Teenpatti markup (.casino-table.teenpatti20), so the teen20 pieces are reused here.
 */
const GAME_TYPE = "teen20v1";
const TITLE = "20-20 Teenpatti VIP";

export default function TeenPatti20Vip() {
  const [gameData, setGameData] = useState({});
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${GAME_TYPE}`;

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(GAME_TYPE);
        setGameData(response || {});
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, []);

  const subData = gameData?.data?.data?.sub;
  const playerAData = useMemo(
    () => (Array.isArray(subData) ? subData.filter((item) => item?.nat?.endsWith("A")) : []),
    [subData]
  );
  const playerBData = useMemo(
    () => (Array.isArray(subData) ? subData.filter((item) => item?.nat?.endsWith("B")) : []),
    [subData]
  );
  const matchId = gameData?.data?.data?.mid?.toString();

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName && exposureAmount !== 0) {
              exposureMap[teamName] = exposureAmount;
              exposureMap[teamName.toLowerCase()] = exposureAmount;
              exposureMap[teamName.trim()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [matchId]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const response = await getCasinoOpenBets(GAME_TYPE);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, []);

  // Admin places no bets: odds click refreshes exposure + open bets
  const handleBetClick = (value) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  useEffect(() => {
    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [matchId, fetchExposure]);

  useEffect(() => {
    const first = setTimeout(fetchMyBetsData, 0);
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => {
      clearTimeout(first);
      clearInterval(intervalId);
    };
  }, [fetchMyBetsData]);

  const d = gameData?.data?.data;
  const roundId = d?.mid || "";

  return (
    <CasinoTableLayout
      tableClass="teenpatti20"
      rightSide={<Teen20RightSide bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name={TITLE} roundId={roundId} />
        <VideoBox
          gameType={GAME_TYPE}
          resultData={d?.card}
          iframeSrc={iframeSrc}
          timerValue={d?.lt}
          cardsOverlay={<Teen20RefCardsOverlay cards={d?.card} />}
        />
        {d?.mid ? (
          <div className="casino-detail">
            <div className="teen20casino-container d-none-small">
              <div className="teen20left">
                <BetTableTeenPatti20c
                  data={playerAData}
                  onBetClick={(value) => handleBetClick(value)}
                  playerName="A"
                  exposures={exposures}
                />
              </div>{" "}
              <div className="teen20center" />{" "}
              <div className="teen20right">
                <BetTableTeenPatti20c
                  data={playerBData}
                  onBetClick={(value) => handleBetClick(value)}
                  playerName="B"
                  exposures={exposures}
                />
              </div>
            </div>{" "}
            <CasinoLastResult
              gameType={GAME_TYPE}
              resultComponent={<Teen20RefResults gameType={GAME_TYPE} fallbackTitle={TITLE} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={GAME_TYPE}
      />
    </CasinoTableLayout>
  );
}
